function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTxTfConstruction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "156.746 195.394 104.504 80.022",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g2689",
    transform: "matrix(0.269018, 0, 0, 0.269018, 156.743912, 195.391449)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    id: "path633",
    d: "M385.98,297.154l-245.615,0.316c-2.224-0.2-3.837-0.708-2.993-3.362l90.25-115.688 c3.12-4.423,7.83-6.815,12.567-6.679l45.352-0.096c7.355-0.004,10.191,2.125,14.238,7.207l88.375,114.12 C388.963,294.979,388.239,296.986,385.98,297.154z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect613",
    d: "M125.665,49.226l35.181,18.466c5.479,2.876,7.761,10.037,5.099,15.995l-41.233,92.255 c-2.664,5.959-9.265,8.458-14.744,5.582l-35.181-18.466c-5.48-2.876-7.763-10.037-5.1-15.995l41.235-92.255 C113.584,48.849,120.185,46.35,125.665,49.226z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect615",
    d: "M71.647,46.625h81.178c5.197,0,9.41,3.583,9.41,8v16.5c0,4.419-4.214,8-9.41,8H71.647 c-5.198,0-9.412-3.581-9.412-8v-16.5C62.235,50.207,66.449,46.625,71.647,46.625z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect616",
    d: "M26.867,118.678l35.457-66.826c2.27-4.279,6.379-5.715,9.177-3.206l10.45,9.367 c2.798,2.509,3.227,8.011,0.956,12.291l-35.457,66.825c-2.27,4.279-6.379,5.716-9.177,3.207l-10.45-9.367 C25.026,128.46,24.597,122.958,26.867,118.678z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect617",
    d: "M59.08,125.656l210.061,110.75c13.451,7.091,23.609,14.378,22.689,16.274l-3.439,7.083 c-0.92,1.896-12.57-2.316-26.02-9.407L52.31,139.606c-13.451-7.091-23.609-14.378-22.689-16.274l3.439-7.083 C33.979,114.353,45.629,118.564,59.08,125.656z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect618",
    d: "M154.473,179.08l-6.267-109.371c-0.401-7.003,2.244-12.909,5.907-13.192l13.682-1.056 c3.665-0.283,6.96,5.166,7.361,12.169l6.267,109.369c0.401,7.003-2.244,12.909-5.907,13.192l-13.682,1.055 C158.169,191.531,154.874,186.083,154.473,179.08z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "path619",
    cx: 181.428,
    cy: 31.625,
    rx: 29.924,
    ry: 31.616,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect621",
    d: "M101.8,228.479l-14.83-61.612c-0.949-3.946,1.674-7.725,5.86-8.441l15.63-2.678 c4.186-0.716,8.349,1.9,9.299,5.846l14.829,61.612c0.949,3.946-1.673,7.725-5.858,8.441l-15.632,2.678 C106.911,235.042,102.749,232.424,101.8,228.479z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect622",
    d: "M102.249,288.088l-0.482-63.512c-0.031-4.066,3.379-7.098,7.613-6.771l15.816,1.222 c4.236,0.327,7.694,3.888,7.725,7.955l0.48,63.51c0.031,4.067-3.377,7.098-7.612,6.771l-15.817-1.22 C105.738,295.717,102.28,292.154,102.249,288.088z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect623",
    d: "M3.303,267.255l62.931-110.552c4.029-7.079,10.177-10.791,13.73-8.292l13.268,9.335 c3.552,2.499,3.165,10.265-0.864,17.343L29.436,285.641c-4.029,7.079-10.177,10.791-13.729,8.292L2.44,284.598 C-1.113,282.099-0.727,274.333,3.303,267.255z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxTfConstruction);
export default __webpack_public_path__ + "static/media/tx_TFConstruction.26b5f996.svg";
export { ForwardRef as ReactComponent };